(function(){
	'use strict';

	// When the notice is dismissed
	$('.smp-header-alert .close').on('click', function() {

		// Set the cookie
		// Expire after 7 days
		createCookie('site_alert_dismissed','true',7);
	});

	/**
	* Helper: create cookie
	* @param cookieName: string
	* @param cookieValue string
	* @param daysToExpire number
	*/
	function createCookie(cookieName,cookieValue,daysToExpire) {

		var date = new Date();
		date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
		document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
	}

}());